export default __webpack_public_path__ + "static/media/regulatory--turn-left-ahead--g2.fd4eb44f.png";